export function getHeaderTemplate(id, setShowModalFilter) {
    if(id){
        return {
            headerToolbar: {
                left: 'filterButton',
                center: 'prev title next',
                right: 'dayGridMonth,listMonth'
            },
            customButtons:{
                filterButton: {
                    text: "Filtros",
                    click: () => {setShowModalFilter(true)}
                }
            }
        }
    }

    return {
        headerToolbar: {
            left: 'today',
            center:'prev title next',
            right:'dayGridMonth,listWeek'
        }
    }
}

export function handleEventClick (info, setClickedTeam, setShowModalInfo) {
    setClickedTeam({
        id: info.event.extendedProps.id,
        name: info.event.title,
        start: info.event.start,
        end: info.event.end,
        users: info.event.extendedProps.users,
        scale: info.event.extendedProps.scale,
        color: info.event.backgroundColor,
        scheduleName: info.event.extendedProps.scheduleName
    });
    setShowModalInfo(true);
}

export function dataSetAndEventDidMount(setFilters, fetchWorkScheduleEvents, setEvents, setMonth, filters){
    return {
        datesSet: (info) => {
            setMonth(info.view.title.toUpperCase());
            const start = info.startStr.split("T")[0];
            const end = info.endStr.split("T")[0];
            setFilters(prevState => ({...prevState, start, end}))
            fetchWorkScheduleEvents({...filters, start, end}).then(setEvents);
        }
    }
}